module.exports = __webpack_public_path__ + "fonts/Noto_Sans_TC-400-95.9b8ba53.woff2";